import React from "react";

import { InputAdornment, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

interface SearchBoxProps {
  value: string;
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  size?: "medium" | "small";
  placeholder?: string;
  fullWidth?: boolean;
}

const SearchBox: React.FC<SearchBoxProps> = ({
  value,
  onSearch,
  onKeyDown,
  size = "small",
  placeholder = "Search",
  fullWidth = false
}) => {
  const theme = useTheme();

  return (
    <TextField
      variant="outlined"
      size={size}
      color="primary"
      value={value}
      onClick={(e) => e.stopPropagation()}
      onFocus={(e) => e.stopPropagation()}
      onChange={onSearch}
      onKeyDown={onKeyDown}
      placeholder={placeholder}
      fullWidth={fullWidth}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <Search fontSize="small" />
            </InputAdornment>
          ),
        },
      }}
      sx={{
        input: {
          maxWidth: fullWidth ? undefined : "200px",
          "& > fieldset": {
            borderColor: value !== "" ? theme.palette.primary.main : "",
          },
          "&::placeholder": {
            color: theme.palette.text.secondary,
            opacity: 1,
          },
        },
      }}
    />
  );
};

export default SearchBox;
